import type { useAiEditActions } from '@/utils/hooks/scheduler/aiCaption/useAiEditActions';
import useTranslation from '@/utils/hooks/translation/useTranslation';

//lib
import { languageSubmenu } from '@/lib/aiCaption/languageSubmenu';
import { toneOfVoiceSubmenu } from '@/lib/aiCaption/toneOfVoiceSubmenu';

type useAiCaptionDropdownOptionsProps = {
    toggleGenerateCaptionModal: () => void;
    toggleGenerateCaptionFromUrlModal: () => void;
    handleEnhanceCaption: ReturnType<typeof useAiEditActions>['handleEnhanceCaption'];
    handleHashtags: ReturnType<typeof useAiEditActions>['handleHashtags'];
    handleToneOfVoiceCaption: ReturnType<typeof useAiEditActions>['handleToneOfVoiceCaption'];
    handleTranslateCaption: ReturnType<typeof useAiEditActions>['handleTranslateCaption'];
    isOptionDisabled: boolean;
};

export function useAiCaptionDropdownOptions({
    toggleGenerateCaptionModal,
    toggleGenerateCaptionFromUrlModal,
    handleEnhanceCaption,
    handleHashtags,
    handleToneOfVoiceCaption,
    handleTranslateCaption,
    isOptionDisabled
}: useAiCaptionDropdownOptionsProps) {
    const { t } = useTranslation('scheduler');

    const dropdownOptions = [
        {
            tag: t('scheduler_funnel.ai_caption.dropdown.tags.generate'),
            options: [
                {
                    label: t('scheduler_funnel.ai_caption.dropdown.options.caption'),
                    callback: toggleGenerateCaptionModal,
                    icon: 'edit-sparkle'
                },
                {
                    label: t('scheduler_funnel.ai_caption.dropdown.options.caption_from_url'),
                    icon: 'link',
                    callback: toggleGenerateCaptionFromUrlModal
                }
            ]
        },
        {
            tag: t('scheduler_funnel.ai_caption.dropdown.tags.edit'),
            options: [
                {
                    icon: 'magic-wand',
                    label: t('scheduler_funnel.ai_caption.dropdown.options.enhance'),
                    callback: handleEnhanceCaption,
                    disabled: isOptionDisabled
                },
                {
                    icon: 'translate',
                    label: t('scheduler_funnel.ai_caption.dropdown.options.translate'),
                    disabled: isOptionDisabled,
                    submenu: languageSubmenu(t, handleTranslateCaption)
                },
                {
                    icon: 'conversations',
                    label: t('scheduler_funnel.ai_caption.dropdown.options.tone_of_voice'),
                    disabled: isOptionDisabled,
                    submenu: toneOfVoiceSubmenu(t, handleToneOfVoiceCaption)
                },
                {
                    icon: 'hashtag',
                    label: t('scheduler_funnel.ai_caption.dropdown.options.hashtags'),
                    disabled: isOptionDisabled,
                    callback: handleHashtags
                }
            ]
        }
    ];
    return dropdownOptions;
}
